import { gql } from "@apollo/client";

export const BELL_UNSEEN_NOTIFICATIONS_COUNT = gql`
    query bellUnseenNotificationsCounts {
        bellUnseenNotificationsCounts {
            counts
        }
    }
`;

export const BELL_UNSEEN_NOTIFCATIONS = gql`
    query bellUnseenNotifications($first: Int, $offset: Int) {
        bellUnseenNotifications(first: $first, offset: $offset) {
            edges {
                node {
                    link
                    linkText
                    notificationType
                    title
                    text
                    createdAt
                    bellNotificationId
                }
            }
            pageInfo {
                endCursor
                hasNextPage
            }
        }
    }
`;
